import { Component, OnInit } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import * as _ from 'underscore';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { AssigTripsService } from 'src/app/service/assigntrips-service/assigntrips-service';
import { DriversService } from 'src/app/service/drivers-service/drivers-service';
import { FleetService } from 'src/app/service/fleet-service/fleet.service';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { formatDuration } from 'src/app/utils/utils.common';
import { LevelOfServiceService } from 'src/app/service/level-of-service/level-of-service.service';
import { PayorService } from 'src/app/service/payor/payor.service';

@Component({
  selector: 'app-otp-list',
  templateUrl: './otp-list.component.html',
  styleUrls: ['./otp-list.component.css']
})
export class OtpListComponent implements OnInit {
  dataList = [];
  filterdataList = [];
  search: any;
  timeZone;
  user;
  drivers;
  preSpaceTypes = {};
  preLevelOfServices = {};
  levelOfServiceList = [];
  selectedLevelOfService;
  spaceTypeList = [];
  todayDate: any;
  preDrivers = {};
  tripDetailModalObj;
  completedTripModalObj;
  isEnabledOneHourException = true;
  prePayorsList:any= {};

  constructor(
    private payorService : PayorService,
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private driverService: DriversService,
    private csvService: CsvService,
    private levelOfServiceService: LevelOfServiceService
  ) { }

  ngOnInit() {
    this.getConfigurations();
    this.getUser();
    this.getPayorList();
  }

  getConfigurations() {
    this.assignTripService
      .getConfigurations({ status: 'active' })
      .subscribe(data => {
        if (data) {
          if (data.levelofservices && data.levelofservices.length) {
            this.levelOfServiceList = data.levelofservices;
            this.preLevelOfServices = data.levelofservices.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }

         
          if (data.spacetypes && data.spacetypes.length) {
            this.spaceTypeList = data.spacetypes;
            this.preSpaceTypes = data.spacetypes.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }

        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.timeZone = data.company.timeZone;
          this.user = data;
          this.todayDate = moment.tz(this.timeZone),
          this.getDrivers();
          this.getTrips();
          if (this.user.company 
            && this.user.company.hasOwnProperty('hideOneHourException')
            && this.user.company.hideOneHourException
          ) {
            this.isEnabledOneHourException = false;
          }
        }
      });
  }

  getTrips() {
    this.clearTrips();
    const object = {
      date: [this.todayDate.startOf("day").toISOString(),this.todayDate.endOf("day").toISOString()],
    };
    this.assignTripService
      .getKpiScore(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.dataList = data;
            this.filterdataList = data;
          }
          this.filterTripsByModel();
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
  }


  filterTripsByModel() {
    this.filterdataList = this.dataList;
    this.filterdataList = new FilterPipe().transform(
      this.filterdataList,
      this.search
    );
    this.filterTrips();

  }

    filterTrips() {
    this.filterdataList = this.dataList.filter(trip => {
      let islosExist = true;




      if (trip.los && this.selectedLevelOfService && this.selectedLevelOfService.length) {
        islosExist = this.selectedLevelOfService.includes(trip.los);
      }

     

      if (islosExist) {
        return true;
      } else {
        return false;
      }
    });
  }

  viewTripDetails(trip) {
    this.tripDetailModalObj = trip;
  }

  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }


  ngOnDestroy(): void {
    this.socketService.removeListener(Events.UPDATE_ASSIGN_TRIP);
    this.sharedDataService.toggleDatePicker(false);
  }

  onDateChange(event) {
    this.todayDate = event;
    this.getTrips();
  }

  getDrivers() {
    this.driverService.getDrivers(this.user.company._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preDrivers = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
  
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  clearTrips() {
    this.filterdataList = [];
    this.dataList = [];
  }

  downloadCsvReport() {
    const data = {
      trips: this.filterdataList,
      preDrivers: this.preDrivers,
      preLevelOfServices: this.preLevelOfServices,
      preSpaceTypes: this.preSpaceTypes,
      timeZone: this.timeZone,
      searchDate: this.todayDate,
      isEnabledOneHourException: this.isEnabledOneHourException,
      prePayorsList : this.prePayorsList
    }
    this.csvService.generateOtpReport(data);
  }

   getPayorList() {

    const param = {
      status: 'active'
    };

    this.payorService
      .getPayorList(param)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data: any) => {
          if (data) {
            this.prePayorsList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }

  formatMinutes(durationValue: any) {
    return formatDuration(durationValue);
  }
}
